// Panel に届かない間（更新・再起動）に edge の Caddy が返すメンテナンス中の応答を見分け、画面全体に知らせる。
// ヘッダー名と code は packages/core/src/maintenance-page.ts と同じ（core は node 用のコードを含むので値だけ写す）。
import { useSyncExternalStore } from 'react';

export const MAINTENANCE_HEADER = 'X-MCPanel-Maintenance';
export const MAINTENANCE_CODE = 'maintenance';

/** idle: ふだん / active: メンテナンス中 / recovered: 戻った（新しい版を読むため再読み込みを勧める） */
export type MaintenanceState = 'idle' | 'active' | 'recovered';

let state: MaintenanceState = 'idle';
const listeners = new Set<() => void>();

function set(next: MaintenanceState) {
  if (state === next) return;
  state = next;
  for (const listener of listeners) listener();
}

export function isMaintenanceResponse(response: Pick<Response, 'status' | 'headers'>): boolean {
  return response.status === 503 && response.headers.get(MAINTENANCE_HEADER) === '1';
}

/** API の応答ごとに呼ぶ。メンテナンス中の応答なら active、それ以外の応答が届いたら（active の後なら）recovered */
export function noteResponse(response: Pick<Response, 'status' | 'headers'>) {
  if (isMaintenanceResponse(response)) set('active');
  else if (state === 'active') set('recovered');
}

export function maintenanceState(): MaintenanceState {
  return state;
}

export function dismissRecovered() {
  if (state === 'recovered') set('idle');
}

export function subscribeMaintenance(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useMaintenance(): MaintenanceState {
  return useSyncExternalStore(subscribeMaintenance, maintenanceState, maintenanceState);
}

/** テスト用 */
export function resetMaintenance() {
  set('idle');
}
